function SectionShareProfile() {
    return (
        <>
            <h4 className="twm-s-title">Share Profile</h4>
            <div className="twm-social-tags">
                <a href="https://www.facebook.com/" className="fb-clr">Facebook</a>
                <a href="http://www.twitter.com/" className="tw-clr">Twitter</a>
                <a href="https://in.linkedin.com/" className="link-clr">Linkedin</a>
                <a href="https://www.whatsapp.com/" className="whats-clr">Whatsapp</a>
                <a href="https://in.pinterest.com/" className="pinte-clr">Pinterest</a>
            </div>
        </>
    )
}

export default SectionShareProfile;